import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import reducers from '../reducers';
import { checkoutMiddleware } from '../middlewares';

const middlewares = applyMiddleware(
    ReduxThunk,
    checkoutMiddleware,
);

const store = createStore(reducers, {}, middlewares);

export default store;

